import { ChangeZoomedAdminArea } from '@resistapp/client/contexts/map-context';
import { zoomAndCenterMap } from '@resistapp/client/contexts/use-overview-context/overview-context-utils';
import { OverviewDatum } from '@resistapp/client/data-utils/plot-data/build-overview-line-data';
import { QueryFilters } from '@resistapp/client/hooks/use-query-filters/use-query-filters';
import { AdminArea, getOriginalSamplingPointId } from '@resistapp/common/types';
import { isNil } from 'lodash';
import type { MapboxMap } from 'react-map-gl';

function getOriginalSamplingPointIds(
  samplingPoint: Pick<OverviewDatum, 'samplingPointAfter' | 'samplingPoint'>['samplingPoint'] | undefined,
): number[] {
  const id = getOriginalSamplingPointId(samplingPoint);
  return id !== undefined ? [id] : [];
}

export function onMarkerClick(
  closeClick: boolean,
  marker: Pick<OverviewDatum, 'samplingPointAfter' | 'samplingPoint'>,
  _navigate: (path: string, keepQuery: boolean) => void,
  toggleSamplingPoint: QueryFilters['toggleSamplingPointStable'],
  adminLevelsActive: boolean,
  changeZoomedAdminAreaStable: ChangeZoomedAdminArea,
  previousAdminArea: AdminArea | undefined,
  mapInstance: MapboxMap | null,
) {
  if (closeClick) {
    // If we select a project, the projectId exists, but if we unselect it is undefined
    toggleSamplingPoint(undefined, true);
    changeZoomedAdminAreaStable(previousAdminArea || undefined, { previous: true });
  } else if (!adminLevelsActive) {
    // Get only the original sampling point IDs, not the bogus negative IDs
    const samplingPointIds = [
      ...getOriginalSamplingPointIds(marker.samplingPoint),
      ...getOriginalSamplingPointIds(marker.samplingPointAfter),
    ];

    toggleSamplingPoint(samplingPointIds, true);
    if (mapInstance && !isNil(marker.samplingPoint.inferredLon) && !isNil(marker.samplingPoint.inferredLat)) {
      zoomAndCenterMap(mapInstance, {
        zoom: 13,
        center: [marker.samplingPoint.inferredLon, marker.samplingPoint.inferredLat],
      });
    }
    changeZoomedAdminAreaStable(null);
  }
}
